<template>
  <div class="bg-brand-black min-h-screen flex lg:bg-white">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto h-12 w-auto my-6 lg:hidden">
        <img src="@/assets/brand/icon.svg" class="h-10 -mt-4 w-auto inline-block" alt="Logo" />
        <span class="text-white font-extrabold text-4xl ml-2 tracking-tight">Churnkey</span>
      </div>
      <div class="mx-auto w-full max-w-screen-sm lg:w-96 shadow-lg lg:shadow-none px-16 py-12 rounded-lg lg:p-0 bg-white">
        <h2 class="text-center text-2xl tracking-tight leading-9 font-extrabold text-brand-black">
          Welcome back to Churnkey<span class="ml-2">👋</span>
        </h2>
        <article class="mt-8" v-loading="pending" v-if="twoFactorExpectingCode">
          <div>
            <span>
              <p class="text-center text-lg font-bold mb-8">Enter the 6-digit code we emailed you</p>
            </span>
            <el-form label-position="top" label-width="100px" @submit.prevent.native="onSubmit">
              <el-form-item>
                <otp-input
                  :digits="6"
                  :gap="20"
                  :isDisabled="false"
                  errorClass="error-class"
                  type="number"
                  placeholder="_"
                  separateWrapperClass="separate-wrapper-class"
                  separateInputClass="separate-input-class"
                  :isValid="isCodeValid"
                  @on-complete="onCompleteCode"
                >
                  <template #errorMessage>{{ twoFactorErrorMessage }}</template>
                </otp-input>
              </el-form-item>
              <el-button native-type="submit" type="primary" class="w-full text-lg"> Verify 2FA code → </el-button>
              <div class="text-sm text-center mt-4">
                <p class="mt-4">
                  Locked out of your account?
                  <a class="text-brand-blue" target="_blank" href="mailto:support@churnkey.co?subject=I cannot access my account">Contact support</a>
                </p>
                <p class="mt-2"><a class="text-brand-blue" href="/login">← Back to Login page</a></p>
              </div>
              <div class="text-center"></div>
            </el-form>
          </div>
        </article>
        <article class="mt-8" v-loading="pending" v-else>
          <div class="mt-4">
            <el-form label-position="top" label-width="100px" @submit.prevent.native="onSubmit">
              <el-form-item class="font-bold" label="Email">
                <el-input placeholder="Email" class="font-medium text-brand-blue" type="email" v-model="email"></el-input>
              </el-form-item>
              <el-form-item class="mt-3 font-bold" label="Password">
                <el-input placeholder="Password" class="font-medium text-brand-blue" show-password v-model="password"></el-input>
              </el-form-item>
              <el-button native-type="submit" type="primary" class="w-full text-md font-bold">Sign In →</el-button>
              <div class="text-center mt-2">
                <el-button class="mr-4 font-bold" type="text" @click="goToRegister()">Create Account</el-button>
                <el-button class="font-bold" type="text" @click="goToReset()">Forgot Password?</el-button>
              </div>
              <div class="text-center"></div>
            </el-form>
          </div>
        </article>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1 bg-brand-black">
      <div class="flex justify-center items-center flex-col h-full">
        <div class="absolute right-8 top-8">
          <p class="text-white font-semibold inline-block">Need an account?</p>
          <span class="inline-block">
            <a href="/register" class="text-brand-yellow hover:underline ml-2 font-bold">Sign up </a>
          </span>
        </div>
        <div class="h-1/3">
          <img src="@/assets/brand/icon.svg" class="h-full -mt-2 w-auto" alt="Logo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN } from '@/store/action-types';
import OtpInput from 'otp-input-vue2';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      code: '',
      pending: false,
      error: null,
    };
  },
  components: {
    OtpInput,
  },
  computed: {
    twoFactorStatus() {
      return this.$store.state.twoFactorStatus;
    },
    twoFactorErrorMessage() {
      return this.$store.state.twoFactorErrorMessage;
    },
    twoFactorExpectingCode() {
      return this.twoFactorStatus === 'required' && this.email && this.password;
    },
    isCodeValid() {
      return !this.twoFactorErrorMessage;
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.pending = true;
        await this.$store.dispatch(LOGIN, {
          email: this.email,
          password: this.password,
          code: this.code,
        });
        if (this.$store.state.authStatus === 'success') {
          this.$router.push('/content');
        } else {
          this.pending = false;
        }
      } catch (err) {
        this.pending = false;
      }
    },
    goToRegister() {
      this.$router.push('/register');
    },
    goToReset() {
      this.$router.push('/password-reset');
    },
    onCompleteCode(code) {
      this.code = code;
      if (!this.pending) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.vue-otp-input {
  width: auto !important;
}
.vue-otp-input ::v-deep .separate-input-class {
  text-align: center;
  font-weight: semibold;
  font-size: 20px;
  width: 12%;
  height: 60px;
  @apply border-2 border-gray-300;
  @apply rounded;
}
.vue-otp-input ::v-deep .error-class .separate-input-class {
  @apply border-2 border-red-500;
}
.vue-otp-input ::v-deep .separate-wrapper-class {
  text-align: center;
}
.vue-otp-input ::v-deep .error-class {
  @apply text-red-500;
  display: block;
  margin-top: 12px;
  line-height: 1.5em;
}
</style>
